import React from "react";
import { Box, SimpleGrid, Text, Link, Icon, Flex } from "@chakra-ui/react";
import { BiFile, BiLinkExternal } from "react-icons/bi";
import { motion } from "framer-motion";

const MotionFlex = motion(Flex);

export const DataField = ({ label, value, ...props }) => (
  <Box {...props}>
    <Text
      fontWeight="500"
      fontSize="10px"
      color="text.secondary"
      lineHeight="18px"
      textTransform="uppercase"
      mb="1"
    >
      {label}
    </Text>
    <Text
      fontWeight="600"
      fontSize="14px"
      color="text.primary"
      lineHeight="18px"
      fontFamily="satoshiBold"
    >
      {value || "-"}
    </Text>
  </Box>
);

export const DocumentField = ({ label, url }) => {
  if (!url) return <DataField label={label} value="Not provided" />;

  return (
    <Box>
      <Text
        fontWeight="500"
        fontSize="10px"
        color="text.secondary"
        lineHeight="18px"
        textTransform="uppercase"
        mb="2"
      >
        {label}
      </Text>
      <Link href={url} isExternal style={{ textDecoration: "none" }}>
        <MotionFlex
          align="center"
          p="3"
          bg="gray.50"
          borderRadius="md"
          border="1px solid"
          borderColor="gray.200"
          whileHover={{ scale: 1.02, bg: "brand.50" }}
          whileTap={{ scale: 0.98 }}
          transition={{ duration: 0.2 }}
        >
          <Icon as={BiFile} w={5} h={5} color="brand.500" mr="3" />
          <Box flex="1" overflow="hidden">
            <Text
              fontSize="12px"
              fontWeight="600"
              color="brand.500"
              isTruncated
              fontFamily="satoshiBold"
            >
              {label}
            </Text>
          </Box>
          <Icon as={BiLinkExternal} w={3} h={3} color="brand.300" />
        </MotionFlex>
      </Link>
    </Box>
  );
};

const SectionLayout = ({ title, children, gridProps }) => {
  return (
    <Box
      bg="white"
      mt="6"
      borderRadius="lg"
      border="1px solid"
      borderColor="gray.100"
      overflow="hidden"
    >
      <Box
        bg="brand.50"
        px="5"
        py="3"
        borderBottom="1px solid"
        borderColor="gray.100"
      >
        <Text
          color="brand.500"
          fontWeight="700"
          fontFamily="satoshiBolder"
          fontSize="14px"
        >
          {title}
        </Text>
      </Box>
      <SimpleGrid
        spacing="6"
        p="5"
        columns={{ base: 1, sm: 2, md: 3, lg: 4 }}
        {...gridProps}
      >
        {children}
      </SimpleGrid>
    </Box>
  );
};

export default SectionLayout;
